export default "__VITE_ASSET__DCjW6JtJ__"